import moment from "moment";

const DomainWebpageColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 90,
    sorter: (a, b) => a.index - b.index
  },
  {
    title: 'Webpage Name',
    dataIndex: 'config_name',
    width: 200,
    sorter: (a, b) => (a.config_name || '').localeCompare(b.config_name || '')
  },
  {
    title: 'Webpage URL',
    dataIndex: 'url_name',
    width: 180,
    slot: 'urls'
  },
  /*{
    title: 'Plan Type',
    dataIndex: 'plan_type',
    width: 130,
    slot: 'plan_type',
    sorter: (a, b) => (a.plan_type || '').localeCompare(b.plan_type || '')
  },*/
  {
    title: 'Polling Interval',
    dataIndex: 'polling_interval',
    width: 150,
    slot: 'polling_interval',
    sorter: (a, b) => (a.polling_interval || 0) - (b.polling_interval || 0)
  },
  {
    title: 'Last Verified',
    dataIndex: 'last_verify',
    width: 150,
    slot: 'last_verify',
    sorter: (a, b) => moment(a.last_verify).diff(moment(b.last_verify)),
  },
  {
    title: 'Status',
    dataIndex: 'health_status',
    width: 200,
    slot: 'status',
    sorter: (a, b) => (a.health_status || '').localeCompare(b.health_status || '')
  },
  {
    title: 'Monitoring Type',
    dataIndex: 'ver_type',
    width: 130,
    slot: 'monitoring_type',
    sorter: (a, b) => (a.ver_type || '').localeCompare(b.ver_type || '')
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation'
  }
];

export { DomainWebpageColumn };
